const USER_AGENT = ["mini_app"];

/**
 * check if in native by userAgent
 */
export function isInNative() {
  let isNative = false;

  try {
    const ua = window.navigator && window.navigator.userAgent;

    // use "userAgent" to identity
    USER_AGENT.forEach((agent) => {
      if (ua.indexOf(agent) > -1) {
        isNative = true;
      }
    });
  } catch (e) {
    console.error(e);
  }

  return isNative;
}
